import React from 'react';
import { ReactComponent as BackgroundSvg } from "../Icons/icon-circle-bg.svg";

interface SvgOverlayProps {
  color: string;
  overlaySvg: JSX.Element;
}

const SvgOverlay: React.FC<SvgOverlayProps> = ({ color, overlaySvg }) => {
  return (
    <div className="svg-overlay-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        className="background-svg">
        <g filter="url(#filter0_f_668_5248)">
          <circle cx="28" cy="28" r="16" fill={color} />
        </g>
        <defs>
          <filter
            id="filter0_f_668_5248"
            x="0"
            y="0"
            width="56"
            height="56"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_668_5248" />
          </filter>
        </defs>
      </svg>
      
      <div className="svg-overlay">
        {overlaySvg}
      </div>
    </div>
  );
};

export default SvgOverlay;
